// Fallback to local devserver id and secret
const client_id = process.env.CLIENT_ID || "xd99W6cJLMsaCktlKr81Z5xkSAXlIyJtvHLnd002";
const client_secret = process.env.CLIENT_SECRET || "sAnwJjXmesVyFSBqF2XSU4I7OABmnpL9ZBFwX9sM1pg9lRPeDaTUOXGrumgWaVYBv3UByM3qbcWmz1c8pCcaeEroY1b3zAnpINPSiV589rHK7h0BpFvoOLLKyfCJ2Hfk";

export default ({
    client_id,
    client_secret
})